import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Subject, BehaviorSubject, Observable,ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthCodeGrantService {

  constructor(private http: RestApi) { }
  aouthUrl = "api/ExternalSystem/Connector/";
  
  //Using any
  public editDataDetails: any = [];
  public subject = new Subject<any>();
  private messageSource = new BehaviorSubject(this.editDataDetails);
  currentMessage = this.messageSource.asObservable();
  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  getServerUrl(): Promise<any> {
    return this.http.get(this.aouthUrl+'UrlServer').pipe(map( data => data.url)).toPromise();
  }

  getTokenOauthCodeGrant(code: string, propertiesList: any[]): Promise<ICredentialTokenOauth> {
    const body = {'code': code, 'properties': propertiesList};
    return this.http.post(this.aouthUrl+'OauthTokenCodeGrant', body).toPromise();
  }

  getTokeClientCredentials(propertiesList: any[]): Promise<ICredentialTokenOauth> {
    const body = {'properties': propertiesList};
    return this.http.post(this.aouthUrl+'OauthTokenClientCredentials', body).toPromise();
  }
}
